module.exports = __webpack_public_path__ + "img/返回.41849225.png";